import React from 'react';
import { FORM_ERROR } from 'final-form';
import cookie from 'js-cookie';

import { CollectingEmailsForm, FormData } from '@components/CollectingEmailsForm';
import apolloWrapper from '@hoc/apolloWrapper';
import {
  getFieldsSingleError,
} from '@utils/common';
import { COLLECTING_EMAILS_COOKIE } from '@constants';

import {
  useCollectingEmailsMutation,
  useUserEmailQuery,
} from './graphql.v4.generated';

// styles
import s from './CollectingEmailsForm.sss';

// type
type CollectingEmailsFormProps = {
  isOpen: boolean;
  onRequestClose: () => void;
};

// constants
const EXPIRE_DAYS_COUNT = 1;

export const CollectingEmailsFormContainer: React.FC<CollectingEmailsFormProps> = ({
  isOpen,
  onRequestClose,
}) => {
  const { data, error } = useUserEmailQuery({
    context: {
      v4: true,
      batch: true,
    },
  });

  const [userUpdateEmail] = useCollectingEmailsMutation({
    context: { v4: true },
  });

  const onClose = () => {
    onRequestClose();
    cookie.set(
      COLLECTING_EMAILS_COOKIE,
      '1',
      {
        expires: EXPIRE_DAYS_COUNT,
      },
    );
  };

  const onSubmit = async (formData: FormData) => {
    const { email } = formData;
    const resp = await userUpdateEmail({
      variables: { email },
    });

    if (resp.data?.userUpdateEmail?.errors?.length) {
      const fromError = getFieldsSingleError(resp.data?.userUpdateEmail.errors);

      return {
        email: fromError.email,
        [FORM_ERROR]: fromError.__all__,
      };
    }
    onClose();

    return undefined;
  };

  if (error) {
    throw error;
  }

  if (data?.viewer && !data?.viewer?.email) {
    return (
      <CollectingEmailsForm
        className={s.modal}
        onSubmit={onSubmit}
        isOpen={isOpen}
        onRequestClose={onClose}
      />
    );
  }

  return null;
};

export default apolloWrapper(CollectingEmailsFormContainer);
